import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth0 } from "./react-auth0-spa";
import { useMsal } from "@azure/msal-react";
import Navbar from "components/Header/Navbar";
import AppRoutes from "./authentication/Routes";
import MainWebSocket from "./websocket";
import { shouldRenderHeader } from "./utils";
import "./App.sass";
import { MyContextProvider } from "hooks/useContext/useContext";
import CorticaLoader from "./components/sharedComponents/CorticaLoader/CorticaLoader";

const UNVERIFIED_USER_PATH = "/unverified_user";

function App() {
  const { loading, needsVerification } = useAuth0();
  const { instance } = useMsal();
  const location = useLocation();
  const [isHandlingRedirect, setIsHandlingRedirect] = useState(true);
  
  MainWebSocket();

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        const hasRedirectParams = urlParams.has('code') || urlParams.has('state') || 
                                 hashParams.has('code') || hashParams.has('state') ||
                                 window.location.hash.includes('access_token') ||
                                 window.location.hash.includes('id_token');
        
        if (hasRedirectParams) {
          console.log("[App] Redirect parameters detected, handling redirect promise...");
          const response = await instance.handleRedirectPromise();
          if (response && response.account) {
            console.log("[App] Redirect handled successfully, account set:", response.account.username);
            instance.setActiveAccount(response.account);
          } else {
            console.log("[App] No redirect response found");
          }
        } else {
          await instance.handleRedirectPromise();
        }
      } catch (error) {
        console.error("[App] Error handling redirect promise:", error);
      } finally {
        setIsHandlingRedirect(false);
      }
    };

    handleRedirect();
  }, [instance]);

  if (loading || isHandlingRedirect) {
    return <CorticaLoader message="Cortica Telehealth" />;
  }

  // Checked before any route renders: Login/PrivateRoute would otherwise send the
  // unverified user back to Auth0, which signs them straight in again.
  if (needsVerification && location.pathname !== UNVERIFIED_USER_PATH) {
    return <Navigate to={UNVERIFIED_USER_PATH} replace />;
  }

  return (
    <MyContextProvider>
      <div>
        <section className="App">
          <div className="body-content">
            {shouldRenderHeader(location.pathname) && <Navbar />}
            <AppRoutes />
          </div>
        </section>
      </div>
    </MyContextProvider>
  );
}

export default App;
